import React, { Component } from 'react';
export default class JobFullDetailsToolsButtonsJobSubcontractor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: props.data || null,
      hasSplitParent: this.props.hasSplitParent || false,
      isSplitJob: this.props.isSplitJob || false,
      hasSplitJobs: this.props.hasSplitJobs || false,
      isSplitJobPartA: this.props.isSplitJobPartA || false,
      isSplitJobPartB: this.props.isSplitJobPartB || false,
      apiUrlForHandleJobSubContractingTo: "/api/v1/portal/jobs/sub-contract-to/",
      isLoading:false,
      isSubbed:false
    };
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      data: nextProps.data
    });
  }
  handleJobSubContractingTo(companyName) {
    this.setState({isLoading:true});
    let yesSubcontractThisJob = confirm(
      'subcontract this job to '+ companyName + '?'
    );
    if (yesSubcontractThisJob) {
      return fetch(
        this.state.apiUrlForHandleJobSubContractingTo+
        companyName+"/"+this.state.data.id,
        {
          method: "POST",
          mode: "cors",
          cache: "no-cache",
          credentials: "same-origin",
          headers: {
            "Authorization": 'Bearer ' + window.api_token,
            "Accept": 'application/json'
          },
        }
      ).then((responseText) => {
          if(responseText.ok){
            this.setState({isLoading:false,showSubContracting:!this.state.showSubContracting,isSubbed:true});
            alert('Job is subcontracted to '+companyName);
          }else{
            alert('Something went wrong!!');
          }
        }
      ).catch((error)=>{
        alert('Something went wrong!!');
      });
    }
    else {
      alert('You cancelled');
    }
  }

  render() {
    return(
      <div>
        {/* <button
          className="btn btn-lg btn-info"
          disabled={(this.state.isSubbed) ? true : false}
          onClick={(e) => {
            this.setState({
              showSubContracting: !this.state.showSubContracting
            });
          }}
        >
          <i className="far fa-calendar-alt"></i>&nbsp;
          Job Subcontractor
        </button> */}
      {
        (this.state.showSubContracting) ?
          <div>
            <p>
              Subcontract this job to:
            </p>
            <button
              className="btn btn-lg btn-outline-dark"
              disabled={(this.state.isLoading) ? true : false}
              onClick={(e) => {
                this.handleJobSubContractingTo(
                  'acv'
                );
              }}
            >
              ACV
            </button>
            <br />
            <br />
            <button
              className="btn btn-lg btn-outline-dark"
              disabled={(this.state.isLoading) ? true : false}
              onClick={(e) => {
                this.handleJobSubContractingTo(
                  'bvl'
                );
              }}
            >
              BVL
            </button>
            <br />
            <br />
            <button
              className="btn btn-lg btn-outline-dark"
              disabled={(this.state.isLoading) ? true : false}
              onClick={(e) => {
                this.handleJobSubContractingTo(
                  'cnd'
                );
              }}
            >
              CND
            </button>
            <br />
            <br />
            <button
              className="btn btn-lg btn-outline-dark"
              disabled={(this.state.isLoading) ? true : false}
              onClick={(e) => {
                this.handleJobSubContractingTo(
                  'g4'
                );
              }}
            >
              G4
            </button>
            <br />
            <br />
            <button
              className="btn btn-lg btn-outline-dark"
              disabled={(this.state.isLoading) ? true : false}
              onClick={(e) => {
                this.handleJobSubContractingTo(
                  'sccd'
                );
              }}
            >
              SCCD
            </button>
          </div>
        :
          ''
      }
    </div>
    )
  }
}